var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"flex--row--align-center content-block-title"},[_c('h4',[_vm._v(_vm._s(_vm.props.title))]),_c('div',{staticClass:"margin--left--auto"},[_c('p',[_vm._v(_vm._s(_vm.props.buttonText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }